var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChatSearch = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  d: "M7.467 1.5c1.647 0 3.139.67 4.219 1.753a5.98 5.98 0 0 1 1.747 4.233 5.97 5.97 0 0 1-1.729 4.21L14.5 14.5l-2.873-2.727a5.93 5.93 0 0 1-4.16 1.698c-1.648 0-3.14-.67-4.22-1.753A5.98 5.98 0 0 1 1.5 7.485c0-1.652.668-3.149 1.748-4.232A5.94 5.94 0 0 1 7.467 1.5Z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgChatSearch);
export default ForwardRef;